<template>
    <div id="app">
		<AppHeader />
		<transition name="slide">
			<router-view/>
		</transition>
    </div>
</template>

<script>
	import AppHeader from "@/components/Header"

	export default {
		components: { 
			AppHeader,
		},
		/* computed: {
			confId(){
				return this.$store.state.confId
			},
			confName(){
				return this.$store.state.confId
			},
		},
		mounted(){
			let confId = this.$route.params.id
			if(confId) {
				this.$store.commit("setConfId", confId)
				this.$store.dispatch("fetchConfProfile", confId)
			}
		} */
	}
</script>

<style >
	td {
		font-size: 12px;
	}
	.bg-danger {
		background-color: #c21f5d!important;
	}
	.bg-primary, .btn-outline-primary:hover{
		background-color: #005daa !important;
	}

	.btn-outline-primary:hover{
		color:#ffffff !important;
	}

	.btn-primary{
		background-color: #005daa !important;
	}

	.text-primary, .btn-link, .btn-outline-primary {
		color: #005daa !important;
	}
	.btn-primary, .btn-outline-primary, .border-primary {
		border-color: #005daa!important;
	}
	button > small{
		font-size:8pt;
		margin:0;
		display:block;
	}
	.bold{
		font-weight: 800;
	}
	.btn-tile{
		cursor: pointer;
	}
	.app-header{
		/* padding: .25rem 0 .5rem; */
		border-bottom: 1px solid #f1f1f1;
	}
	.app-logo{
		width: auto;
		height: 70px;
	}
	.conf-logo{
		width: auto;
		height: 100px;
	}
	.app-header-menu{
		padding: 0rem 1rem;
		text-align: end;
	}
	.index-menu{
		cursor: pointer;
	}
	.index-menu .fas{
		display: none;
	}
	.index-menu:hover{
		background-color: #f9f9f9;
	}
	.index-menu:hover .fas{
		display: block;
	}

	.profile-img{
		width:300px;
		border-radius: 7%;
	}

	.msg-avatar{
		border-radius: 100%;
		position:absolute; 
		bottom:1rem; 
		width:70%;
	}

	.msg-avatar-container{
		position: relative;
	}

	.right-msg-bubble{
		border-radius: 15px;
		border-bottom-right-radius: 0;
	}

	.left-msg-bubble{
		border-radius: 15px;
		border-bottom-left-radius: 0;
	}

	.crew-excerpt{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 4.5em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 3; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.excerpt{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 3em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 2; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.msg-excerpt{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 1.5em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 1; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.msg-highlight{
		border: 1px solid #007bff;
	}

	.msg-title{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 1.5em;
		line-height: 1.5em;
		margin-bottom:-.1rem;
		display: -webkit-box;
		-webkit-line-clamp: 1; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.mkt-title{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 1.5em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 1; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.crew-title{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 1.5em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 1; /* number of lines to show */
		-webkit-box-orient: vertical;
	}

	.crew-subtitle{
		overflow: hidden;
		word-wrap: break-word;
		text-overflow: ellipsis;
		max-height: 3em;
		line-height: 1.5em;
		display: -webkit-box;
		-webkit-line-clamp: 2; /* number of lines to show */
		-webkit-box-orient: vertical;
		margin-top:-.8rem;
	}

	.title-type{
		float: right;
		font-size: 12px;
	}
	.msg-date{
		float: right;
		font-size: 10px;
	}
	.mkt-img{
		border-radius: 5%;
	}
	.pointer{
		cursor: pointer;
	}

	.message-panel{
		background-color: #f1f1f1;
		display: inline-block;
		min-height: 85vh;
		max-height: 85vh;
		overflow: hidden;
		overflow-y: scroll;
	}

	.user-panel{
		display: inline-block;
		min-height: 55vh;
		max-height: 55vh;
		overflow: hidden;
		overflow-y: scroll;
		width: 110%;
	}

	.message-pane{
		padding:2rem;
		display: inline-block;
		min-height: 70vh;
		max-height: 70vh;
		overflow: hidden;
		overflow-y: scroll;
	}

	.message-box{
		background-color: #fff;
		border-top: 1px solid #f1f1f1;
		position:absolute; 
		padding:0 1rem;
		bottom:0; left:0; right:0;
	}
	.marketplace-newitem-alert{
		position:fixed;
		top:0; left:0; right:0;
		z-index: 99;
	}
	.modal-header{
		border:0;
	}
	.card{
		border-radius: .7rem;
	}
	.card-img-top {
		width: 100%;
		border-top-left-radius: calc(.7rem - 1px);
		border-top-right-radius: calc(.7rem - 1px);
	}

	.card-img {
		border-radius: calc(.7rem - 1px);
	}

	.card-img-container{
		min-height: 150px;
		display: block;
	}

	.chat-card-img-container{
		width:100%;
		display: block;
		min-height:360px;
	}
	@media only screen and (max-width: 800px) {
		/* .col-12{
			padding-right: 7px;
			padding-left: 7px;
		} */
		.app-header{
			padding: .5rem 1rem 0rem;
			border-bottom: 1px solid #f1f1f1;
			text-align: left;
		}
		.app-logo{
			width: 100%;
			height: auto;
		}
		.app-header-menu{
			padding: 0rem 0rem;
			background-color: #fff;
			z-index: 99;
			text-align: center;
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			width: 100%;
			border-top: 1px solid #f1f1f1;
		}

		.app-header-menu > .btn-lg {
			padding: .5rem 1.1rem;
		}

		/* .card{
			border:0px solid #f9f9f9;
			box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		} */
		.btn-tile{
			padding-left:0px !important;
			padding-right:0px !important;
		}
		.message-panel{
			background-color: #f1f1f1;
			display: inline-block;
			min-height: 85vh;
			max-height: 85vh;
			overflow: hidden;
			overflow-y: scroll;
		}
		.user-panel{
			width:105%;
			padding-left:.5rem;
			min-height: 65vh;
			max-height: 65vh;
			overflow: hidden;
			overflow-y: scroll;
		}
		.message-pane{
			padding:0 1rem 5rem;
			min-height: 70vh;
			max-height: 70vh;
		}
		.msg-search{
			
		}
		.card-img-container{
			width:100%;
			display: block;
			min-height:300px;
		}
		.chat-card-img-container{
			width:100%;
			display: block;
			min-height:200px;
		}
	}
</style>